export default class ApiError extends Error {
  constructor(message, statusCode, status) {
    super(message);

    this.name = 'ApiError';
    this.statusCode = statusCode;
    this.status = status;
  }
}
